/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react'
import customStyles from "../../../../assets/styles/customStyles";
import clsx from 'clsx';
import { Paper, Grid, Avatar, Box, TextField, Button, InputAdornment, Tooltip, IconButton } from '@mui/material';
import { Link } from "react-router-dom";
import logoImg from "../../../../assets/images/logo.png";
import { Image } from "antd";
import businessLoginImg from "../../../../assets/images/businessLogin.png";
import { AutoCompleteComponent } from "../../../Shared/components/AutoCompleteComponent";
import { useDispatch, useSelector } from "react-redux";
import infoMarkIcon from "../../../../assets/images/icon_actions/infoMark.svg";
import younoteAdminSetupActions from "../../../YounoteAdmin/Setup/redux/actions";
import { emptyValidation, customAlaphaNumericValidationOptional, customAlaphaNumericValidation } from "../../../../helpers/validation";
import closeImg from "../../../../assets/images/icon_menus/Close Button.svg";
import businessActions from "../../../Admin/Home/redux/actions";
import usePrevious from "../../../Shared/components/Previous";
import { toast } from 'react-toastify';
import { storageSetItem, logoutUserIdle } from '../../../../helpers/utilities';


const BusinessDetails = (props) => {
    const { businessProfileDetails, businessProfileError, businessProfileLoader } = useSelector(state => state.homeReducer);
    const { businessDetails } = useSelector(state => state.homeReducer);

    const classes = customStyles();
    const [form, setForm] = useState({
        taxTypeId: businessDetails?.taxTypeId
    })
    const { taxType } = useSelector(state => state.younoteAdminSetupReducer);
    const dispatch = useDispatch();
    const [error, setError] = useState({});
    const { history } = props;
    const registerForm = useRef(null);

    const prevBusinessProfileDetails = usePrevious(businessProfileDetails);
    const prevBusinessProfileError = usePrevious(businessProfileError);

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const handleHeight = () => {
        let wH = window.innerHeight;
        if (registerForm?.current) {
            let rH = registerForm.current.clientHeight + 50;
            if (wH < rH) {
                registerForm.current.style.height = "100%";
                let cH = registerForm.current.children[0];
                registerForm.current.classList.add("registerForm");
                cH.style.height = "100%";
                cH.children[1].style.height = "calc(100% - 190px)";
            }
        }
    }

    const changeHandler = (e, name = '') => {
        if (name !== '') {
            setForm({
                ...form,
                [name]: e,
            });
        }
        else {
            setForm({
                ...form,
                [e.target.name]: e.target.value
            });
        }
    }


    useEffect(() => {
        if (businessDetails?.countryId) {
            dispatch({
                type: younoteAdminSetupActions.TAX_TYPE_START,
                url: `/tax-types/byCountry/${businessDetails.countryId}`
            });
            setForm({ taxTypeId: businessDetails?.taxTypeId });
            handleHeight();
        }
    }, [businessDetails])

    const handleSubmit = (e) => {
        e.preventDefault();
        let emptyPrice = emptyValidation('Price Tax', form?.priceIncludesTax);
        let emptyGstType = emptyValidation('GST Type', form?.taxTypeId);
        let emptyGst = [];
        if (form?.taxTypeId !== '') {
            let a = taxType && taxType?.filter((el) => el.id === form?.taxTypeId);
            if (a && a.length > 0 && (a[0].taxCode === 'UNRB' || a[0].taxCode === 'COMP' || a[0].taxCode === 'CONS')) {
                emptyGst = customAlaphaNumericValidationOptional('Gst Number', form.gst, 15);
            } else {
                emptyGst = customAlaphaNumericValidation('Gst Number', form.gst, 15);
            }
        }

        if (emptyPrice.isValid && emptyGstType.isValid && emptyGst.isValid) {
            form.priceIncludesTax = form?.priceIncludesTax === 'yes' ? true : false;
            let data = Object.fromEntries(Object.entries(form).filter(([_, v]) => v !== null && v !== ''));
            dispatch({
                type: businessActions.UPDATE_BUSINESS_PROFILE_DETAILS_START,
                updateData: data
            });
        } else {
            setError({
                priceIncludesTax: emptyPrice.errors,
                taxTypeId: emptyGstType.errors,
                gst: emptyGst.errors,
            })
        }
    }

    useEffect(() => {
        if (prevBusinessProfileDetails !== undefined && businessProfileDetails && prevBusinessProfileDetails !== businessProfileDetails) {
            toast.dismiss();
            toast('Business profile updated successfully');
            storageSetItem('event', 'NONE');
            history.push("/");
        } else if (prevBusinessProfileError !== undefined && businessProfileError && prevBusinessProfileError !== businessProfileError) {
            toast.dismiss();
            toast.error(businessProfileError.error.message);
        }
    }, [businessProfileDetails, businessProfileError]);


    return (
        <div className={clsx(classes.backgroundWhite, classes.boxBorder1)}>
            <Paper className={clsx(classes.authContainer)} sx={{ p: 2 }}>
                <Grid container className={clsx(classes.authRoor, classes.fullHei)}>
                    <Link to='#' className={classes.customLogoLink}>
                        <Avatar
                            alt='Logo'
                            src={logoImg}
                            variant={'square'}
                            className={classes.customLogo}
                        />
                    </Link>
                    <Link to='#' className={classes.CloseIcon} onClick={() => logoutUserIdle(props)}>
                        <Image className={clsx(classes.disInline, classes.cursor)}
                            src={closeImg}
                            preview={false}
                        />
                    </Link>
                    {/* <Image
                        src={CloseIcon}
                        preview={false}
                        className={classes.closeBusiness}
                        onClick={() => { handleClose() }}
                    /> */}
                    <Grid xxl={7} xl={7} lg={7} md={7} sm={5} item className={classes.mobileDisplay}>
                        <Image
                            alt="Business"
                            preview={false}
                            src={businessLoginImg}
                            variant={'square'}
                        />
                    </Grid>
                    <Grid xxl={5} xl={5} lg={5} md={5} sm={7} xs={12} item className={clsx(classes.registerForm, classes.customRegisterForm)}>
                        <Paper className={clsx(classes.cardSize, classes.designBusiness, classes.loginForm)} ref={registerForm} style={{ backgroundColor: 'transparent' }}>
                            <Box
                                className={clsx(classes.removeUnderline, classes.businessDesignBox)}
                                component='form'
                                autoComplete='off'
                                onSubmit={(e => handleSubmit(e))}>
                                <div>
                                    <h6 className={clsx(classes.customTitle, classes.primaryFont, classes.bold, classes.typeAlignCenter)}>
                                        Welcome Onboard!
                                    </h6>
                                    <h4 variant="h6" style={{ paddingRight: 0 }} className={clsx(classes.margin20t, classes.textAlignCenter, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>
                                        Please Complete the below details
                                    </h4>
                                </div>
                                <div className={classes.registerFormFields}>
                                    <AutoCompleteComponent
                                        name={["Price Includes Tax ",
                                            <span key={"Price Includes Tax"}
                                                className={classes.colorRedRequired}> *</span>]}
                                        heads={[{ key: 'name', name: 'Name' }]}
                                        details={[{ id: "yes", name: "Yes" }, { id: "no", name: "No" }]}
                                        parentValue={customObject([{ id: "yes", name: "Yes" }, { id: "no", name: "No" }], form.priceIncludesTax)}
                                        onChange={(item) => changeHandler(item.id, 'priceIncludesTax')}
                                        position={'bottom'}
                                        customClasses={clsx(classes.margin30t)}
                                        infoMark={'By selecting YES, the system assumes the unit  price entered for the product in the bill lines includes tax'}
                                        parentError={error?.priceIncludesTax}
                                    />
                                    <AutoCompleteComponent
                                        name={["GST Type ", <span key={"GST Type"}
                                            className={classes.colorRedRequired}> *</span>]}
                                        heads={[{ 'key': 'name', 'name': 'Name' },
                                        { 'key': 'taxCode', 'name': 'Code' }]}
                                        details={taxType}
                                        parentValue={customObject(taxType, form?.taxTypeId)}
                                        onChange={(item) => {
                                            changeHandler(item.id, 'taxTypeId');
                                            if (form.gstNumber) {
                                                changeHandler('', 'gstNumber')
                                            }
                                        }}
                                        position={"bottom"}
                                        customClasses={clsx(classes.margin30t)}
                                        infoMark={'Select the appropriate GST Type if the business is registered for GST. In case if the business is not registered for GST then select the GST Type as Un-Registered.'}
                                        parentError={error?.taxTypeId}
                                    />
                                    {
                                        (customObject(taxType, form?.taxTypeId)?.taxCode === 'RERB' ||
                                            customObject(taxType, form?.taxTypeId)?.taxCode === 'SPEZ' ||
                                            customObject(taxType, form?.taxTypeId)?.taxCode === 'NRTP' ||
                                            customObject(taxType, form?.taxTypeId)?.taxCode === 'CATP'
                                        ) && (
                                            <TextField
                                                label={["GST Number(GSTIN)",
                                                    <span key={"GST Number(GSTIN)"}
                                                        className={classes.colorRedRequired}> *</span>]}
                                                name={'gst'}
                                                fullWidth
                                                error={error?.gst && true}
                                                helperText={error?.gst}
                                                value={form?.gst}
                                                variant={'standard'}
                                                className={clsx(classes.margin30t)}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    }
                                                }}
                                                InputLabelProps={{
                                                    className: classes.textFieldLableColorCustom,
                                                }}
                                                onChange={(e) => changeHandler(e)}
                                            />
                                        )
                                    }
                                    <TextField
                                        label={'Number Sequence Prefix'}
                                        fullWidth
                                        name={'sequencePrefix'}
                                        variant={'standard'}
                                        className={clsx(classes.margin30t)}
                                        value={form?.sequencePrefix}
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor,
                                            },
                                            endAdornment: (
                                                <InputAdornment position="end" className={classes.customToolTipBusiness}>
                                                    <Tooltip
                                                        classes={{ popper: classes.customToolTip }}
                                                        title={'Enter Max of 3 Characters of your choice to have a Prefix for system auto generated numbers. For Example, If you enter number sequence prefix as ASD then your starting sequence for customer will be ASDC0001, your supplier will be ASDV00001 and Product will be ASDPR00001'} arrow
                                                        placement="top"
                                                        className={classes.tooltip}>
                                                        <IconButton>
                                                            <Image src={infoMarkIcon} preview={false} />
                                                        </IconButton>
                                                    </Tooltip>
                                                </InputAdornment>
                                            )
                                        }}
                                        onChange={(e) => changeHandler(e)}
                                        InputLabelProps={{
                                            className: classes.textFieldLableColorCustom,
                                        }}
                                    />
                                </div>
                                <div>
                                    <Button
                                        type='submit'
                                        color='primary'
                                        variant="contained"
                                        fullWidth
                                        className={clsx(classes.margin30t, classes.modalBtn, { [classes.loading]: businessProfileLoader })}>Confirm</Button>
                                </div>
                            </Box>
                        </Paper>
                    </Grid>
                </Grid>
            </Paper>
        </div>
    )
}

export default BusinessDetails    